import { render } from "./EditableValue.vue?vue&type=template&id=15c029d4&scoped=true"
import script from "./EditableValue.vue?vue&type=script&lang=js"
export * from "./EditableValue.vue?vue&type=script&lang=js"

import "./EditableValue.vue?vue&type=style&index=0&id=15c029d4&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c029d4"]])

export default __exports__